"use strict";

var _regeneratorRuntime = require("/home/runner/work/prodigies-brochure/prodigies-brochure/node_modules/.pnpm/@babel+runtime@7.19.0/node_modules/@babel/runtime/regenerator");

require("regenerator-runtime/runtime");

var _slicedToArray = require("/home/runner/work/prodigies-brochure/prodigies-brochure/node_modules/.pnpm/@babel+runtime@7.19.0/node_modules/@babel/runtime/helpers/slicedToArray");

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useBulkActions = void 0;

var lodash_1 = require("lodash");

var react_1 = __importDefault(require("react"));

var ProgressModal_1 = require("./ProgressModal");

var CHUNK_SIZE = 5;

function useBulkActions(_ref) {
  var _this = this;

  var process = _ref.process,
      label = _ref.label,
      _ref$completeLabel = _ref.completeLabel,
      completeLabel = _ref$completeLabel === void 0 ? 'Complete!' : _ref$completeLabel,
      onError = _ref.onError,
      _ref$chunkSize = _ref.chunkSize,
      chunkSize = _ref$chunkSize === void 0 ? CHUNK_SIZE : _ref$chunkSize;

  var _react_1$default$useS = react_1.default.useState(false),
      _react_1$default$useS2 = _slicedToArray(_react_1$default$useS, 2),
      loading = _react_1$default$useS2[0],
      setLoading = _react_1$default$useS2[1];

  var _react_1$default$useS3 = react_1.default.useState(0),
      _react_1$default$useS4 = _slicedToArray(_react_1$default$useS3, 2),
      current = _react_1$default$useS4[0],
      setCurrent = _react_1$default$useS4[1];

  var _react_1$default$useS5 = react_1.default.useState(0),
      _react_1$default$useS6 = _slicedToArray(_react_1$default$useS5, 2),
      total = _react_1$default$useS6[0],
      setTotal = _react_1$default$useS6[1];

  var run = function run(items) {
    return __awaiter(_this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
      var _this2 = this;

      var chunks, _loop, i;

      return _regeneratorRuntime.wrap(function _callee2$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              setLoading(true);
              setTotal(items.length);
              setCurrent(0);
              chunks = (0, lodash_1.chunk)(items, chunkSize);
              _context3.prev = 4;
              _loop = /*#__PURE__*/_regeneratorRuntime.mark(function _loop(i) {
                var currentChunk, isLastChunk;
                return _regeneratorRuntime.wrap(function _loop$(_context2) {
                  while (1) {
                    switch (_context2.prev = _context2.next) {
                      case 0:
                        currentChunk = chunks[i];
                        isLastChunk = i === chunks.length - 1;
                        _context2.next = 4;
                        return Promise.all(currentChunk.map(function (item, index) {
                          return __awaiter(_this2, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
                            var isLastItem;
                            return _regeneratorRuntime.wrap(function _callee$(_context) {
                              while (1) {
                                switch (_context.prev = _context.next) {
                                  case 0:
                                    isLastItem = isLastChunk && index === currentChunk.length - 1;
                                    _context.next = 3;
                                    return process(item, isLastItem);

                                  case 3:
                                    setCurrent(function (c) {
                                      return c + 1;
                                    });

                                  case 4:
                                  case "end":
                                    return _context.stop();
                                }
                              }
                            }, _callee);
                          }));
                        }));

                      case 4:
                      case "end":
                        return _context2.stop();
                    }
                  }
                }, _loop);
              });
              i = 0;

            case 7:
              if (!(i < chunks.length)) {
                _context3.next = 12;
                break;
              }

              return _context3.delegateYield(_loop(i), "t0", 9);

            case 9:
              i++;
              _context3.next = 7;
              break;

            case 12:
              _context3.next = 18;
              break;

            case 14:
              _context3.prev = 14;
              _context3.t1 = _context3["catch"](4);

              if (onError) {
                onError(_context3.t1);
              }

              return _context3.abrupt("return", false);

            case 18:
              setCurrent(items.length);
              return _context3.abrupt("return", new Promise(function (resolve) {
                setTimeout(function () {
                  setLoading(false);
                  resolve(true);
                }, 2000);
              }));

            case 20:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee2, null, [[4, 14]]);
    }));
  };

  return {
    run: run,
    progressModal: react_1.default.createElement(ProgressModal_1.ProgressModal, {
      visible: loading,
      current: current,
      total: total,
      buildLeftLabel: function buildLeftLabel(current1, total1) {
        return current1 !== total ? "".concat(label, " (").concat(current1, " / ").concat(total1, ")") : completeLabel;
      }
    })
  };
}

exports.useBulkActions = useBulkActions;